import React, { memo } from 'react'

// Libraries
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { PropTypes } from "prop-types";
import FancyTextBox from '../../Components/FancyTextBox/FancyTextBox'
import { fadeIn } from "../../Functions/GlobalAnimations";


// Components
import SocialIcons from '../SocialIcon/SocialIcons'
import { Footer } from './Footer'


// Data
const iconData = [
    {
        color: "#dc2626", // Modern red color
        link: "https://www.linkedin.com/company/oman-tower-company/",
        icon: "fab fa-linkedin",
      },
      {
        color: "#16a34a", // Modern green color  
        link: "https://www.instagram.com/omantower/",
        icon: "fab fa-instagram",
      },
      {
        color: "#dc2626", // Modern red color
        link: "https://twitter.com/omantower?lang=en",
        icon: "fab fa-twitter",
      },
      {
        color: "#16a34a", // Modern green color
        link: "https://www.youtube.com/channel/UC5WKC7f3IzF8j4f_6k3mJ_g",
        icon: "fab fa-youtube",
      },
  ];
  const fancyTextBox02 = [
    {
        icon: {
            class: "line-icon-Phone text-red-600"
        },
        title: "Contact Us",
        description: "Feel Free to Call Us in Working Hours",
        linkTitle: "+968-22843222",
        link: "http://www.omantowerco.om/contact-us"
    },
  
  ]

const FooterStyle09 = (props) => {
    return (
        <Footer 
            className={`footer-style-09 modern-footer${props.className ? ` ${props.className}` : ""}`} 
            theme={props.theme}
            style={{
                borderTop: '3px solid transparent',
                borderImage: 'linear-gradient(90deg, #dc2626, #16a34a, #dc2626) 1',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            {/* Semi-transparent overlay */}
            <div 
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    zIndex: 0
                }}
            />
            
            {/* Animated background elements */}
            <div 
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'radial-gradient(circle at 20% 80%, rgba(220, 38, 38, 0.03) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(22, 163, 74, 0.03) 0%, transparent 50%)',
                    animation: 'pulse 4s ease-in-out infinite',
                    opacity: 0.3,
                    zIndex: 1
                }}
            />
            
            <Container className="footerContent relative z-10">
                <Row className="items-center py-8">
                    <Col 
                        className="text-left last:m-0 md:mt-[25px]"
                        style={{
                            animation: 'slideInLeft 0.8s ease-out'
                        }}
                    >
                        <Link aria-label="link" to="/" className="inline-block">
                            <img 
                                src={props.logo} 
                                alt="logo" 
                                width="100" 
                                height="36" 
                                className="mb-[15px] md:mt-0 transition-transform duration-300 hover:scale-110" 
                                style={{
                                    filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))'
                                }}
                            />
                        </Link>
                        <p 
                            className='text-left text-gray-700 font-medium'
                            style={{
                                background: 'linear-gradient(90deg, #dc2626, #16a34a)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text'
                            }}
                        >
                            &copy; Copyright {new Date().getFullYear()} <Link 
                                aria-label="link" 
                                to="/" 
                                rel="noreferrer" 
                                className="underline underline-offset-4 font-semibold hover:text-red-600 transition-colors duration-300"
                                style={{
                                    background: 'linear-gradient(90deg, #dc2626, #16a34a)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text'
                                }}
                            >Oman Tower</Link>
                        </p>
                    </Col>
                    
                    <Col
                        style={{
                            animation: 'fadeInUp 0.8s ease-out 0.2s both'
                        }}
                    >
                        <div className="transform hover:scale-105 transition-transform duration-300">
                            <FancyTextBox
                                grid="justify-center row-cols-1 row-cols-md-12 row-cols-lg-12 gap-y-[30px] xs:gap-y-[15px]"
                                theme="fancy-text-box-02"
                                data={fancyTextBox02}
                                animation={fadeIn} 
                            />
                        </div>
                    </Col>

                    <Col 
                        className="text-center md:text-right mb-[10px]"
                        style={{
                            animation: 'slideInRight 0.8s ease-out 0.4s both'
                        }}
                    >
                        <span 
                            className="mb-[15px] block text-right sm:text-center leading-[18px] font-medium text-gray-700"
                            style={{
                                background: 'linear-gradient(90deg, #16a34a, #dc2626)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text'
                            }}
                        >
                            Connect with social
                        </span>
                        <div className="transform hover:scale-105 transition-transform duration-300">
                            <SocialIcons 
                                theme="social-icon-style-01" 
                                className="justify-end sm:justify-center" 
                                size="xs" 
                                iconColor={props.theme === "dark" ? "light" : "dark"} 
                                data={iconData} 
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            
            <style jsx>{`
                @keyframes slideInLeft {
                    from {
                        opacity: 0;
                        transform: translateX(-30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                
                @keyframes slideInRight {
                    from {
                        opacity: 0;
                        transform: translateX(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes pulse {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.8;
                    }
                }
                
                .modern-footer {
                    backdrop-filter: blur(10px);
                    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
                }
                
                .modern-footer::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 2px;
                    background: linear-gradient(90deg, #dc2626, #16a34a, #dc2626);
                    animation: shimmer 2s ease-in-out infinite;
                }
                
                @keyframes shimmer {
                    0% {
                        background-position: -100% 0;
                    }
                    100% {
                        background-position: 100% 0;
                    }
                }
            `}</style>
        </Footer>
    )
}

FooterStyle09.defaultProps = {
    logo: "/assets/img/webp/logo-gradient-sky-blue-pink-white.webp"
}

FooterStyle09.propTypes = {
    className: PropTypes.string,
    logo: PropTypes.string,
}


export default memo(FooterStyle09)